var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sidebar_db",
    "data-name": "Sidebar Database Icon",
    transform: "translate(-3.5 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5,6.009c0,1.662-4.029,3.009-9,3.009s-9-1.347-9-3.009S8.529,3,13.5,3s9,1.347,9,3.009Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,18c0,1.665-4,3.009-9,3.009s-9-1.344-9-3.009",
    transform: "translate(0 -5.005)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,7.5V21.493c0,1.659,4,3,9,3s9-1.339,9-3V7.5",
    transform: "translate(0 -1.491)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDb);
export default __webpack_public_path__ + "static/media/db.627624fd2ce0ec91d49b37ece3ee3a25.svg";
export { ForwardRef as ReactComponent };